import axios from 'axios';
import QS from 'qs';
import { Toast, Loading } from 'tspuser-toc-vue-modules';
import router from 'pages/router';

const service = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_URL_PMALL}`,
  timeout: 12000,
});
// post请求头
service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 请求拦截
service.interceptors.request.use((config) => {
  console.log('request config', config);
  Loading();
  return config;
}, (error) => {
  setTimeout(() => {
    Loading.close();
    Toast('加载超时');
  }, 3000);
  return Promise.reject(error);
});
// 响应拦截
service.interceptors.response.use(
  (response) => {
    Loading.close();
    // console.log('response:', response.config.params.lottery_id);
    const errData = response.data;
    if (errData && errData.msg && errData.code !== 200) {
      // 401 token 失效或者其他原因
      if (errData.code === 401) {
        console.log('401 token失效或者其他原因');
        // store.commit('doLogin', '');
        // // store.dispatch('login')
        // window.serviceError('14101');

        const backUrl = `https://${window.location.host}${window.location.pathname}#/?lotteryId=${response.config.params.lottery_id}`;
        wx.miniProgram.redirectTo({
          url: `/pages/auth/auth?type=to&pageType=login&loginType=1&url=${encodeURIComponent(backUrl)}`,
        });
      } else // 跳到错误页面
      if (errData.msg !== '令牌为空') {
        const { msg } = errData;
        Toast(msg);
      }
      // return Promise.reject(errData);
    }
    return response;
  },
  (error) => {
    if (!error.response) {
      Toast('网络开小差，请重试~');
    }
    Loading.close();
    router.push('/error');
    return Promise.reject(error);
  },
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    service.get(url, {
      params,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
/**
* post方法，对应post请求
* @param {String} url [请求的url地址]
* @param {Object} params [请求时携带的参数]
*/
export function post(url, params) {
  return new Promise((resolve, reject) => {
    service.post(url, QS.stringify(params))
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
/**
 * 封装后的axios方法
 * @param apiUrl 后端给出的api地址
 * @param params 传给后端的参数
 */
export const ajax = (apiUrl, params) => {
  let data = '';
  if (params) {
    for (const key in params) {
      data = `${data}&${key}=${params[key]}`;
    }
    // data = `${encodeURIComponent(JSON.stringify(params))}`;
  }
  return service({
    url: `${apiUrl}${data}`,
    method: 'post',
    options: {
      data: params,
    },
  });
};
